import React, { useState } from 'react';
import { useKeenSlider } from 'keen-slider/react';
import { ArrowLeft, ArrowRight } from 'lucide-react';
import 'keen-slider/keen-slider.min.css';

const industriesData = [
  {
    id: 1,
    title: "Retail & Ecommerce",
    desc: "We help make shopping easier and more enjoyable by using AI to suggest the right products, manage stock better, and create smooth experiences across all channels, so customers feel more connected and satisfied.",
    image: "/assets/transforming/img4.png"
  },
  {
    id: 2,
    title: "Manufacturing & Logistics",
    desc: "Optimize supply chains, integrate telemetry pipelines, and streamline production modules dynamically to ensure maximum operational capability and safe logistics pipelines.",
    image: "/assets/transforming/img4.png"
  },
  {
    id: 3,
    title: "Healthcare & Life Sciences",
    desc: "Empower patient care and research facilities under secure low-latency automation networks, leveraging advanced models for personalized diagnostics and workflow execution.",
    image: "/assets/transforming/img4.png"
  }
];

const OurIndustriesSection = () => {
  const [loaded, setLoaded] = useState(false);

  const [sliderRef, instanceRef] = useKeenSlider({
    loop: true,
    initial: 0,
    slides: {
      perView: 1,
      spacing: 0,
    },
    created() {
      setLoaded(true);
    }
  });

  return (
    <section className="w-full bg-[#FFFFFF] py-16 sm:py-20 lg:py-24 overflow-hidden select-none text-left">
      <div className="max-w-[1440px] w-full mx-auto px-5 sm:px-10 lg:px-[80px]">

        <div className="w-full mb-12 lg:mb-16">
          <h2 className="text-[#01386A] font-sora font-[600] lg:text-[30px] text-[20px] leading-[1.2] tracking-tight">
            Our Industries
          </h2>
        </div>

        <div ref={sliderRef} className="keen-slider w-full">
          {industriesData.map((item) => (
            <div key={item.id} className="keen-slider__slide w-full flex flex-col md:flex-row items-center gap-10 lg:gap-16">

              <div className="w-full md:w-[50%] aspect-[16/10] md:aspect-[4/3] lg:aspect-[16/10] rounded-none overflow-hidden relative">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover"
                />
              </div>

              <div className="w-full md:w-[50%] flex flex-col items-start justify-center">
                <div className="max-w-[480px] w-full">
                  <h3 className="text-[#01386A] font-sora text-[16px] sm:text-[20px] font-semibold tracking-tight leading-snug mb-5">
                    {item.title}
                  </h3>
                  <p className="text-[#49577A] font-graphik text-[14px] sm:text-[16px] leading-relaxed font-[500] mb-8">
                    {item.desc}
                  </p>

                  {loaded && instanceRef.current && (
                    <div className="flex items-center gap-3">
                      <button
                        onClick={() => instanceRef.current?.prev()}
                        className="w-9 h-9 border border-[#ED7A3A] bg-transparent flex items-center justify-center text-[#ED7A3A] hover:bg-[#ED7A3A] hover:text-white transition-all duration-300 cursor-pointer rounded-full"
                        aria-label="Previous slide"
                      >
                        <ArrowLeft size={16} strokeWidth={2} />
                      </button>
                      <button
                        onClick={() => instanceRef.current?.next()}
                        className="w-9 h-9 border border-[#ED7A3A] bg-transparent flex items-center justify-center text-[#ED7A3A] hover:bg-[#ED7A3A] hover:text-white transition-all duration-300 cursor-pointer rounded-full"
                        aria-label="Next slide"
                      >
                        <ArrowRight size={16} strokeWidth={2} />
                      </button>
                    </div>
                  )}
                </div>
              </div>

            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default OurIndustriesSection;